import type { ReactNode } from 'react';
import { Col } from 'react-bootstrap';
import RequestResetLinkSection from './RequestResetLinkSection';
import { ViewLayoutWrapper } from '@/pages/_layouts/publicLayout/layoutDesktop/LayoutDesktop.styles';

const ForgotPasswordLayoutWrap = ({ children }: { children: ReactNode }) => (
  <ViewLayoutWrapper>
    <Col sm={8} md={8} lg={7} xl={5}>
      {children}
    </Col>
  </ViewLayoutWrapper>
);

const ForgotPassword = () => (
  <ForgotPasswordLayoutWrap>
    <RequestResetLinkSection />
  </ForgotPasswordLayoutWrap>
);

export default ForgotPassword;
